import styled from 'styled-components';
import { ConditionalRenderer } from '../ConditionalRenderer/ConditionalRenderer';
import { IconInfoCircle } from '../icons/cdl/InfoCircle';
import { variant } from 'styled-system';
import { theme } from '../ui/theme';

const Wrapper = styled.div(
    {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        padding: '18px 24px 18px 0',
        borderRadius: '4px',
    },
    variant({
        prop: 'type',
        variants: {
            danger: {
                border: '1px solid',
                borderColor: 'negative.border',
                backgroundColor: 'negative.background',
            },
            white: {
                backgroundColor: 'white',
            },
        },
    })
);

const IconWrapper = styled.div`
    position: absolute;
    height: 24px;

    margin: auto;
    top: 0;
    left: 24px;
    bottom: 0;
`;

const Container = styled.div`
    display: flex;
    width: 100%;
    padding: 0;
`;

const LeftArea = styled.div`
    flex: ${(props) => (props.$hasRightElement ? '2' : '1')};
    display: flex;
    align-items: center;
    padding: 0;
`;

const RightElementWrapper = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0;
`;

const HeadlinesWrapper = styled.div`
    margin-left: 40px;
    padding-left: 24px;
`;

const Headline = styled.h3`
    font-size: 14px;
    font-weight: ${theme.fontWeights[700]};

    line-height: 1.5;
    margin: 0;
`;

const SubHeadline = styled.h4`
    font-size: 14px;
    font-weight: ${theme.fontWeights[400]};

    line-height: 1.5;
    margin: 0;
`;

/**
 * @deprecated use CDL StatusBar instead
 */

export const StatusBar = (props) => {
    const icon = props.icon ?? <IconInfoCircle />;
    const className = props.className ?? '';

    return (
        <Wrapper className={className} type={props.type}>
            <Container>
                <LeftArea $hasRightElement={!!props.rightElement}>
                    <IconWrapper>{icon}</IconWrapper>

                    <HeadlinesWrapper>
                        <Headline>{props.headline}</Headline>

                        <SubHeadline>{props.subHeadline}</SubHeadline>
                    </HeadlinesWrapper>
                </LeftArea>

                <ConditionalRenderer condition={!!props.rightElement}>
                    <RightElementWrapper>
                        <div>{props.rightElement}</div>
                    </RightElementWrapper>
                </ConditionalRenderer>
            </Container>
        </Wrapper>
    );
};
